export default new class CategoriesPanelList {
  constructor() {
    this.listSelector = 'categories-panel__list';
    this.listItemSelector = 'categories-panel__item';
    this.listButton = 'categories-panel__list_button';
    this.listOpened = 'categories-panel__list_opened';

    this.childrenList = 'categories-panel-children';
    this.childrenVisibleClass = 'categories-panel-children--visible';
    this.childrenButtonClass = 'categories-panel-children__btn';
    this.childrenButtonOpenClass = 'categories-panel-children__btn--open';
    this.childrenButtonCloseClass = 'categories-panel-children__btn--close';

    this.init();
  }

  init() {
    this.expandCategories();
    this.findChildren();
  }

  expandCategories() {
    $(document).on('click', `.${this.listButton}`, function openCloseList() {
      $(this).closest('ul').children('li:nth-child(n+5)').slideToggle('');
      $(this).toggleClass(`${this.listOpened}`);

      if ($(this).hasClass(`${this.listOpened}`)) {
        this.buttonText = $(this).html();
        $(this).html('Скрыть');
      } else {
        $(this).html(this.buttonText);
      }
    });
  }

  findChildren() {
    const childrenList = document.querySelectorAll(`.${this.childrenList}`);

    childrenList.forEach(
      (childrenItem) => {
        const catregory = childrenItem.parentElement;

        const btn = catregory.querySelector(`.${this.childrenButtonClass}`);
        this.openChildren(btn, childrenItem);
      },
    );
  }

  openChildren(btn, childrenItem) {
    btn.addEventListener('click', () => {
      childrenItem.classList.add(this.childrenVisibleClass);
      btn.classList.remove(this.childrenButtonOpenClass);
      btn.classList.add(this.childrenButtonCloseClass);
      this.closeChildren(btn, childrenItem);
    });
  }

  closeChildren(btn, childrenItem) {
    btn.addEventListener('click', () => {
      childrenItem.classList.remove(this.childrenVisibleClass);
      btn.classList.remove(this.childrenButtonCloseClass);
      btn.classList.add(this.childrenButtonOpenClass);
      this.openChildren(btn, childrenItem);
    });
  }
}();
